import React, { useState, useEffect } from "react";
import SidebarList, { SidebarItem } from "./SidebarList";
import { useSelector, useDispatch } from "react-redux";
import { RootState, AppDispatch } from '../../redux/store';
import {
	faObjectGroup,
} from "@fortawesome/free-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { extractProducts } from "../../redux/userSlice";
import { useNavigate } from "react-router-dom";
import {faAngleDoubleLeft, faAngleDoubleRight, faChevronLeft, faChevronRight} from "@fortawesome/free-solid-svg-icons";
import ToolTip from "../ToolTip";
import {IconButton} from "../button/IconButton";
interface SidebarAnalysisProps {
  isSmallScreen: boolean;
}
export default function SidebarAnalysis({ isSmallScreen }: SidebarAnalysisProps) {
	const { user, loading, error } = useSelector((state: RootState) => state.user);
	const [isExpanded, setIsExpanded] = useState(true);

	const handleToggle = () => {
		setIsExpanded(prevState => !prevState);
	};

	useEffect(()=> {
		if(isSmallScreen && isExpanded) {
			setIsExpanded(false);
		}
		if(!isSmallScreen && !isExpanded) {
			setIsExpanded(true)
		}
	},[isSmallScreen])

	const hoverText = isExpanded ? 'Collapse' : 'Expand';

	const products: string[] = extractProducts(user) as string[];

	const [content, setContent] = useState<React.ReactNode>();
	const sidebarItems: SidebarItem[][] = products.map((product) => [{
		id: 0,
		label: product,
		icon: <FontAwesomeIcon icon={faObjectGroup} />,
		url: '',
		children: [
			{
				label: "Query",
				url: "/analysis/query"
				//content: <QueryBuilder />,
			}, {
				label: "Saved Queries",
				url: "/analysis/savedqueries"
				//content: <>Ssaved qieries</>
			}
		]
	}
	]);
	const navigate = useNavigate();
	if (location.pathname === '/analysis' || location.pathname === '/') {
		navigate('/analysis/query');
	}

	return (
		<div className={`side-bar analysis ${isExpanded ? 'expand' : 'collapse'}`}>
			<div className="toggle-button-container">
				<span className="nav-title h4">{isExpanded && "QUERY TOOL"}
					<IconButton onClick={handleToggle}>
						<span style={{ fontWeight: 'normal' }}>
							<ToolTip icon={isExpanded ? faChevronLeft : faChevronRight} message={hoverText} position={'right'} />
						</span>
					</IconButton>
				</span>
				<SidebarList sidebarItems={sidebarItems} handleClick={setContent} />
			</div>
		</div>
	);
}
